import { IconButton, InputAdornment } from "@mui/material"
import BaseInput from "../BaseInput"

const BaseIconInput = (props) => {
  const { startIcon, endIcon, onClickStartIcon, onClickEndIcon, ...otherProps } = props
  
  return (
    <BaseInput
      InputProps={{
        startAdornment:
          startIcon ? 
            <InputAdornment position="start">
              <IconButton
                aria-label="start icon visibility"
                onClick={onClickStartIcon}
                edge="start"
              >
                {startIcon}
              </IconButton>
            </InputAdornment> : null,
        endAdornment: 
          endIcon ? 
            <InputAdornment position="end">
              <IconButton
                aria-label="end icon visibility"
                onClick={onClickEndIcon}
                edge="end"
              >
                {endIcon}
              </IconButton>
            </InputAdornment> : null
      }}
      {...otherProps}
    />
  )
}

export default BaseIconInput